import Section from './Section.vue'
import { sortFirstDepositTiersByAmountAsc } from './tierSort'

/** 1 随机 2 固定 3 不赠送 */
const REWARD_RANDOM = 1
const REWARD_FIXED = 2
const REWARD_NONE = 3

// 展示时间字段：show_start_at / show_end_at

function createEmptyFirstDepositTier() {
  return {
    id: '',
    amount_yuan: 100,
    reward_type: REWARD_FIXED,
    reward_count_yuan: undefined,
    reward_count_min: undefined,
    reward_count_max: undefined,
  }
}

function normalizeTierFromApi(tier, ctx) {
  const { centsToYuanNumber } = ctx
  const rewardType = Number(tier?.reward_type)
  const rt = rewardType === REWARD_RANDOM ? REWARD_RANDOM : rewardType === REWARD_NONE ? REWARD_NONE : REWARD_FIXED
  const base = {
    id: tier?.id != null ? String(tier.id) : '',
    amount_yuan: centsToYuanNumber(Number(tier?.amount) || 0),
    reward_type: rt,
    reward_count_yuan: undefined,
    reward_count_min: undefined,
    reward_count_max: undefined,
  }
  if (rt === REWARD_RANDOM) {
    const arr = Array.isArray(tier?.reward_count_arr) ? tier.reward_count_arr : []
    return {
      ...base,
      reward_count_min: centsToYuanNumber(Number(arr[0]) || 0),
      reward_count_max: centsToYuanNumber(Number(arr[1]) || 0),
    }
  }
  if (rt === REWARD_FIXED) {
    return {
      ...base,
      reward_count_yuan: centsToYuanNumber(Number(tier?.reward_count) || 0),
    }
  }
  return base
}

export const firstDepositRewardModule = {
  type: 9,
  component: Section,
  reset(localForm) {
    localForm.firstDepositTiers = [createEmptyFirstDepositTier()]
    if (localForm.firstDepositRule) {
      localForm.firstDepositRule.multiple = 1
    }
    // 展示时间已移至配置信息区域，由顶层组件统一管理
    localForm.vips = []
  },
  fillFromActivity(localForm, raw, ctx) {
    const cfg = raw.first_payin_act_config || raw.config || {}
    const rule = cfg.rule && typeof cfg.rule === 'object' ? cfg.rule : {}

    if (localForm.firstDepositRule) {
      localForm.firstDepositRule.multiple = Number.isFinite(Number(rule.multiple)) ? Number(rule.multiple) : 1
    }

    if (Array.isArray(cfg.vips)) {
      localForm.vips = cfg.vips.map(v => Number(v)).filter(v => Number.isFinite(v))
    }

    const rawTiers = Array.isArray(cfg.tiers) ? cfg.tiers : []
    if (rawTiers.length > 0) {
      localForm.firstDepositTiers = sortFirstDepositTiersByAmountAsc(rawTiers.map(t => normalizeTierFromApi(t, ctx)))
    } else {
      localForm.firstDepositTiers = [createEmptyFirstDepositTier()]
    }
  },
  validate(localForm, ctx) {
    const { Message, yuanToCents } = ctx
    const rules = localForm.firstDepositRule || {}
    const mult = Number(rules.multiple)
    if (!Number.isFinite(mult) || mult <= 0) {
      Message.error('请输入大于0的奖励稽核倍数')
      return false
    }

    // 校验展示时间（时间范围）
    const displayRange = localForm.displayTimeRange
    console.log('displayRange', displayRange)

    if (!Array.isArray(displayRange) || displayRange.length !== 2 || !displayRange[0] || !displayRange[1]) {
      Message.error('请选择展示时间')
      return false
    }

    const tiers = localForm.firstDepositTiers || []
    if (tiers.length === 0) {
      Message.error('请至少配置一条存款档位')
      return false
    }

    for (let i = 0; i < tiers.length; i += 1) {
      const t = tiers[i]
      const row = i + 1
      const amt = Number(t.amount_yuan)
      if (!Number.isFinite(amt) || amt <= 0) {
        Message.error(`第${row}行存款金额须大于0`)
        return false
      }
      const rt = Number(t.reward_type)
      if (rt === REWARD_RANDOM) {
        const min = Number(t.reward_count_min)
        const max = Number(t.reward_count_max)
        if (!Number.isFinite(min) || min < 0 || !Number.isFinite(max) || max < 0) {
          Message.error(`第${row}行随机奖励区间须填写合法数字`)
          return false
        }
        if (max < min) {
          Message.error(`第${row}行随机奖励上限须大于等于下限`)
          return false
        }
      } else if (rt === REWARD_FIXED) {
        const rc = Number(t.reward_count_yuan)
        if (!Number.isFinite(rc) || rc <= 0) {
          Message.error(`第${row}行固定奖励金额须大于0`)
          return false
        }
      }
    }

    const sortedTiers = sortFirstDepositTiersByAmountAsc(tiers)
    for (let i = 1; i < sortedTiers.length; i += 1) {
      const prev = yuanToCents(Number(sortedTiers[i - 1].amount_yuan))
      const cur = yuanToCents(Number(sortedTiers[i].amount_yuan))
      if (cur <= prev) {
        Message.error('存款档位须按存款金额从小到大配置，且门槛不能重复或冲突')
        return false
      }
    }
    localForm.firstDepositTiers = sortedTiers
    return true
  },
  buildPayload(localForm, ctx) {
    const { yuanToCents } = ctx
    const rules = localForm.firstDepositRule || {}
    const sorted = sortFirstDepositTiersByAmountAsc(localForm.firstDepositTiers || [])
    const tiers = sorted.map((t, idx) => {
      const rt =
        Number(t.reward_type) === REWARD_RANDOM
          ? REWARD_RANDOM
          : Number(t.reward_type) === REWARD_NONE
          ? REWARD_NONE
          : REWARD_FIXED
      const base = {
        index: idx + 1,
        amount: yuanToCents(Number(t.amount_yuan)) || 0,
        reward_type: rt,
      }
      if (t.id != null && t.id !== '') base.id = String(t.id)
      if (rt === REWARD_RANDOM) {
        return {
          ...base,
          reward_count: 0,
          reward_count_arr: [
            yuanToCents(Number(t.reward_count_min)) || 0,
            yuanToCents(Number(t.reward_count_max)) || 0,
          ],
        }
      }
      if (rt === REWARD_FIXED) {
        return {
          ...base,
          reward_count: yuanToCents(Number(t.reward_count_yuan)) || 0,
        }
      }
      return {
        ...base,
        reward_count: 0,
      }
    })

    // 展示时间转换（时间范围字符串 -> Unix 秒）
    const { toUnixSeconds } = ctx
    const showStartAt = localForm.displayTimeRange?.[0] ? toUnixSeconds(localForm.displayTimeRange[0]) : 0
    const showEndAt = localForm.displayTimeRange?.[1] ? toUnixSeconds(localForm.displayTimeRange[1]) : 0

    return {
      first_payin_act_config: {
        description: '',
        rule: {
          multiple: Number(rules.multiple) || 0,
        },
        vips: [...(localForm.vips || [])].sort((a, b) => a - b),
        tiers,
      },
      show_start_at: showStartAt,
      show_end_at: showEndAt,
    }
  },
}
